import { usePosMode } from '@/features/pos/contexts/PosMode'
import { useEffect, useRef } from 'react'

export const useCloseOnPosModeChange = (onClose: () => void): void => {
    const mode = usePosMode()

    const shouldSkipInitialEffectRun = useRef(true)

    useEffect(() => {
        if (shouldSkipInitialEffectRun.current) {
            shouldSkipInitialEffectRun.current = false

            return
        }

        onClose()
    }, [mode, onClose])
}
